import { get } from "lodash"
import useResource from "hooks/resources"
import { ResourceResult } from "helpers/data-statuses"
import type { ReduxState } from "model/state"

const EMPTY_ARRAY: Basket[] = []

export interface Basket {
  ticker: string
  description: string
  availableFrom: string
  terminationDate: string
  currencyOverride: string
  lastUpdated: string
}

export const BASKETS_QUERY = {
  resource: "baskets",
  url: () => ({
    id: "baskets",
    query: "query { baskets: swaps { ticker, description, availableFrom, terminationDate, currencyOverride, lastUpdated } }",
  }),
}

export function useBaskets(): ResourceResult<Basket[]> {
  return useResource(BASKETS_QUERY, "baskets")
}

export function getBaskets(state: ReduxState) {
  return get(state, "global.data.baskets.data.baskets", EMPTY_ARRAY)
}
